import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerData, CustomerComponentData } from '../customer.model';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { readOnly, readWrite } from '../../user/user-permission/user-permission.data';
import { routerTransition } from '../../shared/animations/router.animations';
import * as _ from 'lodash';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerService } from '../customer.service';

@UntilDestroy()
@Component({
    selector: 'ifb-customer-profile',
    templateUrl: './customer-profile.component.html',
    styleUrls: ['./customer-profile.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class CustomerProfileComponent implements OnInit {
  customerInfoData: CustomerData;
  canEditCustomerInfo: boolean;
  salesforceViewMode: boolean;
  canReadCustomerIdentity: boolean;
  canUseIdentityActions: boolean;
  canEditCustomerIdentity: boolean;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly userPermissionService: UserPermissionService,
    private readonly customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this.route.params.pipe(untilDestroyed(this))
      .subscribe(params => this.salesforceViewMode = params.uniqueId !== undefined);

    this.route.data.pipe(untilDestroyed(this))
      .subscribe((data: CustomerComponentData) => this.setData(data?.customer));

    this.userPermissionService.granted([readWrite('servicing-customers')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canEditCustomerInfo = res);

    this.userPermissionService.granted([readOnly('servicing-customers-verification-status')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canUseIdentityActions = res);

    this.userPermissionService.granted([readWrite('servicing-customers-verification-status')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canEditCustomerIdentity = res);

    this.userPermissionService.granted([readOnly('servicing-customers-identification-data')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canReadCustomerIdentity = res);
  }

  private setData(data: CustomerData): void {
    if (data) {
      this.customerInfoData = data;
      this.customerInfoData.accountType = _.trim(data.accountType, '#$');
    }
  }

  refreshCustomerData(): void {
    this.customerService.get(this.customerInfoData.id).subscribe((data: CustomerData) => this.setData(data));
  }
}
